import { Athlete } from "./athlete";
import { Team } from "./team";
import { Address } from "./address";
import { User } from "./user";

interface CoachData {
  id?: number;
  specializations?: string;
  userId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  rights?: string[];

  user?: User;
  athletes?: Athlete[];
  teams?: Team[];
  address?: Address;

}

export class Coach {
  public static getNonTranslatableFields(): string[] { return ['id', 'specializations', 'userId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'specializations', 'userId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  specializations?: string;
  userId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  rights?: string[];

  user?: User;
  athletes?: Athlete[];
  teams?: Team[];
  address?: Address;


  public static fromAPI(data: CoachData): Coach {
    if (data.user) {
      data.user = User.fromAPI(data.user);
    }
    if (data.athletes) {
      data.athletes = Athlete.fromAPIList(data.athletes);
    }
    if (data.teams) {
      data.teams = Team.fromAPIList(data.teams);
    }
    if (data.address) {
      data.address = Address.fromAPI(data.address);
    }
    return new Coach(data);
  }

  public static fromAPIList(data: CoachData[]): Coach[] {
    return data.map((item: CoachData) => Coach.fromAPI(item));
  }

  constructor({id, specializations, userId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId, rights, user, athletes, teams, address} : CoachData) {
    this.id = id;
    this.specializations = specializations;
    this.userId = userId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;

    this.rights = rights;

    this.user = user;
    this.athletes = athletes;
    this.teams = teams;
    this.address = address;
  }


  public toJson(): CoachData {
    return {
      id: this.id,
      specializations: this.specializations,
      userId: this.userId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }

}
